export function initializeModes(vm) {
  return [
    {
      name: "SELECT",
      value: 0,
      enabled: vm.active === 0,
      enableFunction: function () {
        vm.enableMeasurementPointDragMode();
        vm.enableDragControls();
        vm.restoreDefaultNavigation();
        document.addEventListener("click", vm.selectMeasurementArea, false);
        window.addEventListener("dblclick", vm.addZoomCenter, false);
        document.addEventListener(
          "mousemove",
          vm.detectMeasurementIntersection,
          false
        );
        document.addEventListener(
          "mousemove",
          vm.detectIntesectionForCursorChange,
          false
        );
        document.addEventListener(
          "mousemove",
          vm.detectAuxiliaryMeasurementIntersection,
          false
        );
        document.addEventListener(
          "click",
          vm.detectPersistentMeasurementIntersection,
          false
        );
      },
      disableFunction: function () {
        vm.disableMeasurementPointDragMode();
        vm.disableDragControls();
        document.removeEventListener("click", vm.selectMeasurementArea, false);
        window.removeEventListener("dblclick", vm.addZoomCenter, false);
        document.removeEventListener(
          "mousemove",
          vm.detectMeasurementIntersection,
          false
        );
        document.removeEventListener(
          "mousemove",
          vm.detectIntesectionForCursorChange,
          false
        );
        document.removeEventListener(
          "click",
          vm.detectPersistentMeasurementIntersection,
          false
        );
        document.removeEventListener(
          "mousemove",
          vm.detectAuxiliaryMeasurementIntersection,
          false
        );
      },
    },
    {
      name: "DISTANCE_MEASUREMENT",
      value: 1,
      enabled: vm.active === 1,
      enableFunction: function () {
        vm.enableDragControls();
        document.addEventListener("click", vm.addMarker, false);
        document.addEventListener(
          "mousemove",
          vm.detectMeasurementIntesectionForCursorChange,
          false
        );
        document.addEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        document.addEventListener("keydown", vm.removeLastDistancePoint, false);
      },
      disableFunction: function () {
        document.removeEventListener("click", vm.addMarker, false);
        document.removeEventListener(
          "mousemove",
          vm.detectMeasurementIntesectionForCursorChange,
          false
        );
        document.removeEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        document.removeEventListener(
          "keydown",
          vm.removeLastDistancePoint,
          false
        );
        vm.removeUnfinishedMeasurements();
        vm.disableDragControls();
      },
    },
    {
      name: "SOLAR_AREA",
      value: 2,
      enabled: vm.active === 2,
      enableFunction: function () {
        document.addEventListener("click", vm.addPoint, false);
        document.addEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        document.addEventListener(
          "mousemove",
          vm.detectSolarAreaIntersection,
          false
        );
        document.addEventListener("keydown", vm.removeLastPoint, false);
        vm.showAreas();
        vm.showRestrictedAreas();
        vm.setPanelsTransparent();
        vm.enablePointDragMode();
      },
      disableFunction: function (nextMode) {
        vm.clearMagnetEffect();
        if (nextMode === 2) return;

        document.removeEventListener("click", vm.addPoint, false);
        document.removeEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        document.removeEventListener(
          "mousemove",
          vm.detectSolarAreaIntersection,
          false
        );
        document.removeEventListener("keydown", vm.removeLastPoint, false);
        document.removeEventListener(
          "mousemove",
          vm.detectSolarAreaPointsIntersection,
          false
        );
        document.removeEventListener(
          "mousemove",
          vm.detectIndividualPanels,
          false
        );
        document.removeEventListener(
          "mousedown",
          vm.dragIndividualPanelStart,
          false
        );
        document.removeEventListener("click", vm.selectSolarArea, false);
        vm.cleanPanelSetup();
        vm.disablePointDragMode();
        vm.removeUnfinshedArea();
        if (nextMode !== "fromPanOrbiting") {
          vm.deselectSolarArea();
          vm.hideRestrictedAreas();
          vm.hideAreas(false);
          vm.setPanelsOpaque();
        }
      },
    },
    {
      name: "INDIVIDUAL_PLACEMENT",
      value: 3,
      enabled: vm.active === 3,
      enableFunction: function () {
        document.addEventListener(
          "mousemove",
          vm.updateCursorForIndividualPlacement,
          false
        );
        document.addEventListener("click", vm.addIndividualPanel, false);
        vm.hideRestrictedAreaDetails(this.selectedArea);
        vm.hideAreaLabelIcons();
        vm.disablePointDragMode();
      },
      disableFunction: function () {
        document.removeEventListener(
          "mousemove",
          vm.updateCursorForIndividualPlacement,
          false
        );
        document.removeEventListener("click", vm.addIndividualPanel, false);
        vm.individualPanelOrientation = null;
        vm.active = 2;
        vm.showAreaLabelIcons();
        vm.showRestrictedAreaDetails(vm.selectedArea);
        vm.enablePointDragMode();
        vm.enablePointDragModeForRestrictedAreas();
      },
    },
    {
      name: "AREA_MEASUREMENT",
      value: 4,
      enabled: vm.active === 4,
      enableFunction: function () {
        document.addEventListener("click", vm.addMeasurementPoint, false);
        document.addEventListener(
          "mousemove",
          vm.detectIntesectionForCursorChange,
          false
        );
        document.addEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        document.addEventListener(
          "keydown",
          vm.removeLastMeasurementPoint,
          false
        );
        vm.enableMeasurementPointDragMode();
      },
      disableFunction: function () {
        document.removeEventListener("click", vm.addMeasurementPoint, false);
        document.removeEventListener(
          "mousemove",
          vm.detectIntesectionForCursorChange,
          false
        );
        document.removeEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        document.removeEventListener(
          "keydown",
          vm.removeLastMeasurementPoint,
          false
        );
        vm.removeUnfinishedAreaMeasurements();
        vm.clearMagnetEffect();
        vm.disableMeasurementPointDragMode();
      },
    },
    {
      name: "GALLERY",
      value: 5,
      enabled: vm.active === 5,
      enableFunction: function (fromPanOrbit = false) {
        vm.disableDefaultNavigation();
        if (fromPanOrbit) {
          document.addEventListener("click", vm.selectPointOnModel, false);
        }
      },
      disableFunction: function () {
        vm.removeGalleryPoint();
        vm.resetBestImage();
        vm.toggleFullScreenImageActive(false);
        document.removeEventListener("click", vm.selectPointOnModel, false);
      },
    },
    {
      name: "RESTRICTED_AREA",
      value: 6,
      enabled: vm.active === 6,
      enableFunction: function () {
        vm.cleanPanelSetup();
        document.addEventListener("click", vm.addRestrictedAreaPoint, false);
        document.addEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        vm.showAreas();
        vm.showRestrictedAreaDetails(vm.selectedArea);
        vm.hideAreaLabelIcons();
        vm.disablePointDragMode();
        vm.disableIndividualPlacementListeners();
      },
      disableFunction: function () {
        vm.removeUnfinishedRestrictedAreas();
        vm.mouseOverPoint = false;
        document.removeEventListener("click", vm.addRestrictedAreaPoint, false);
        document.removeEventListener(
          "mousemove",
          vm.detectModelIntersection,
          false
        );
        vm.active = 2;
        vm.showAreaLabelIcons();
        vm.enablePointDragModeForRestrictedAreas();
        vm.enablePointDragMode();
        vm.enableIndividualPlacementListeners();
      },
    },
  ];
}
